import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { uploadLimitsService } from '../../services/uploadLimitsService';
import './admin-uploads.css';

/** Envío AP-2 · Usuarios › (usuario) › Plan: qué plan de subida tiene. */
export default function UserUploadPlanTab({ user }) {
  const [data, setData] = useState(null);
  const [choice, setChoice] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    uploadLimitsService.getUserPlan(user.user_id)
      .then((res) => { if (alive) { setData(res); setChoice(res.plan || ''); } })
      .catch((err) => toast.error(err?.response?.data?.detail || 'No se pudo leer el plan'));
    return () => { alive = false; };
  }, [user.user_id]);

  if (!data) return <div className="admin-empty"><Loader2 size={20} className="spin" /> Cargando…</div>;

  const plans = data.config?.plans || {};
  const defaultId = data.config?.default_plan;
  const shown = plans[choice || defaultId] || {};

  const save = async () => {
    setBusy(true);
    try {
      const res = await uploadLimitsService.setUserPlan(user.user_id, choice);
      setData((d) => ({ ...d, plan: res.plan, effective: res.effective }));
      toast.success('Plan de subida actualizado');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'No se pudo guardar');
    } finally { setBusy(false); }
  };

  return (
    <div className="sml-adu-plan" data-testid="admin-user-upload-plan">
      <label htmlFor="sml-adu-user-plan">Plan de subida</label>
      <select id="sml-adu-user-plan" value={choice} onChange={(e) => setChoice(e.target.value)}>
        <option value="">Por defecto ({plans[defaultId]?.label || defaultId})</option>
        {Object.entries(plans).map(([id, p]) => <option key={id} value={id}>{p.label}</option>)}
      </select>
      <dl>
        <dt>Imagen</dt><dt>Video</dt><dt>Audio</dt>
        <dd>{shown.image_mb} MB</dd><dd>{shown.video_mb} MB</dd><dd>{shown.audio_mb} MB</dd>
      </dl>
      <div>
        <button type="button" className="admin-btn admin-btn-grant" onClick={save}
                disabled={busy || choice === (data.plan || '')} data-testid="admin-user-upload-plan-save">
          {busy && <Loader2 size={12} className="spin" />} Guardar plan
        </button>
      </div>
      <p className="admin-tab-help">Los planes y sus límites se editan en la pestaña Subidas.</p>
    </div>
  );
}
